import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/tickets-readOnly.svg',
})
export class TicketReadOnlyIconComponent {}
